<template>
    <div>
        <div class="layout-popup-contents">
            <div class="step-container">
                <p v-if="isCopy">{{$t('POLICY.RULE.POPUP.DESC.RULE_COPY_DESC')}}</p>
                <p v-if="isEdit">{{$t('POLICY.RULE.POPUP.DESC.RULE_EDIT_DESC')}}</p>
                <p v-if="!isCopy && !isEdit">{{$t('POLICY.RULE.POPUP.DESC.RULE_CREA_DESC')}}</p>
            </div>
            <div class="scroll-container" :key="rule.ruleId">
                <fieldset class="forms">
                    <legend>{{$t('POLICY.BUTTON.ADD_RULE')}}</legend>
                    <div class="vstack">
                            <!--FOR EN-->
                        <div class="form-item">
                            <label for="r_name" class="textfield-with">{{$t('POLICY.RULE.TITLE')}} in English<span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                            <input ref="input_title" type="text" id="r_name" :placeholder="$t('POLICY.RULE.PLACEHOLDER.TITLE')"
                                class="text-field"
                                style="width: 600px;"
                                :data-invalid="invalidRuleTitle"
                                v-model="rule.enRuleTitle"
                                @input="rule.enRuleTitle = $event.target.value; isInvalidRuleTitle();"
                                @focusout="isInvalidRuleTitle()">
                                    <p class="invalid-message" v-if="invalidRuleTitle">
                                        {{invalidRuleTitleMsg}}
                                    </p>
                        </div>
                        <!--FOR KO-->
                        <div class="form-item">
                            <label for="r_name" class="textfield-with">{{$t('POLICY.RULE.TITLE')}} in Korean <span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                            <input ref="input_title" type="text" id="r_name" :placeholder="$t('POLICY.RULE.PLACEHOLDER.TITLE')"
                                class="text-field"
                                style="width: 600px;"
                                :data-invalid="invalidRuleTitle"
                                v-model="rule.koRuleTitle"
                                @input="rule.koRuleTitle = $event.target.value; isInvalidRuleTitle();"
                                @focusout="isInvalidRuleTitle()">
                                    <p class="invalid-message" v-if="invalidRuleTitle">
                                        {{invalidRuleTitleMsg}}
                                    </p>
                        </div>
                        <!--FOR ZH-->
                        <div class="form-item">
                            <label for="r_name" class="textfield-with">{{$t('POLICY.RULE.TITLE')}} in China<span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                            <input ref="input_title" type="text" id="r_name" :placeholder="$t('POLICY.RULE.PLACEHOLDER.TITLE')"
                                class="text-field"
                                style="width: 600px;"
                                :data-invalid="invalidRuleTitle"
                                v-model="rule.zhRuleTitle"
                                @input="rule.zhRuleTitle = $event.target.value; isInvalidRuleTitle();"
                                @focusout="isInvalidRuleTitle()">
                                    <p class="invalid-message" v-if="invalidRuleTitle">
                                        {{invalidRuleTitleMsg}}
                                    </p>
                        </div>

                        <!-- 설명 -->
                        <!--FOR EN-->
                        <div class="form-item">
                            <label for="r_desc" class="textfield-with">{{$t('LABEL.DESCRIPTION')}} in English</label>
                            <textarea name="" id="r_desc" class="textarea" :placeholder="$t('POLICY.RULE.PLACEHOLDER.DESC')"
                                      :invalid="invalidRuleDesc ? true : null"
                                      v-model="rule.enRuleDesc"
                                      @input="rule.enRuleDesc = $event.target.value; isInvalidRuleDesc();"
                                      @focusout="isInvalidRuleDesc()"></textarea>
                            <p class="invalid-message" v-if="invalidRuleDesc">{{$t('SETTING.WHITELIST.ERROR.MAX', {'cnt' :'4000'})}}</p>
                        </div>
                         <!--FOR KO-->
                        <div class="form-item">
                            <label for="r_desc" class="textfield-with">{{$t('LABEL.DESCRIPTION')}} in Korean</label>
                            <textarea name="" id="r_desc" class="textarea" :placeholder="$t('POLICY.RULE.PLACEHOLDER.DESC')"
                                      :invalid="invalidRuleDesc ? true : null"
                                      v-model="rule.koRuleDesc"
                                      @input="rule.koRuleDesc = $event.target.value; isInvalidRuleDesc();"
                                      @focusout="isInvalidRuleDesc()"></textarea>
                            <p class="invalid-message" v-if="invalidRuleDesc">{{$t('SETTING.WHITELIST.ERROR.MAX', {'cnt' :'4000'})}}</p>
                        </div>
                         <!--FOR ZH-->
                        <div class="form-item">
                            <label for="r_desc" class="textfield-with">{{$t('LABEL.DESCRIPTION')}} in China</label>
                            <textarea name="" id="r_desc" class="textarea" :placeholder="$t('POLICY.RULE.PLACEHOLDER.DESC')"
                                      :invalid="invalidRuleDesc ? true : null"
                                      v-model="rule.zhRuleDesc"
                                      @input="rule.zhRuleDesc = $event.target.value; isInvalidRuleDesc();"
                                      @focusout="isInvalidRuleDesc()"></textarea>
                            <p class="invalid-message" v-if="invalidRuleDesc">{{$t('SETTING.WHITELIST.ERROR.MAX', {'cnt' :'4000'})}}</p>
                        </div>

                        <!-- 카테고리 레이블 -->
                        <div class="form-item popout-layer">
                            <label class="textfield-with">{{$t('POLICY.RULE.CATEGORY_LABEL')}} <span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>

                            <select-box-multi select-id="rule-select-ctg"
                                select-class="type-tagging"
                                place-holder="FILTER.SELECT_CATEGORY_PLEASE"
                                :use-labels="true"
                                :use-translate="true"
                                :select-box-options="getCtgFilterOptions"
                                :select-box-value="rule.ctgLabel"
                                :data-invalid="invalidRuleCtgLabel"
                                @onSelectChange="rule.ctgLabel = $event.value; isInvalidRuleCategoryLabel()"></select-box-multi>
                            <p class="invalid-message" v-if="invalidRuleCtgLabel">{{$t('POLICY.RULE.INVALID.CATEGORY_LABEL')}}</p>
                        </div>

                        <div class="form-item popout-layer">
                            <label class="textfield-with">{{$t('LABEL.SEVERITY')}} <span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                            <select-box-single select-id="select_svrty"
                                select-class="type-single"
                                :use-translate="true"
                                :select-box-options="svrtyOptions"
                                :select-box-value="rule.svrty"
                                @onSelectChange="rule.svrty = $event.value"></select-box-single>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="layout-popup-footer">
            <div class="left-view">
                <button type="button" class="buttons" data-type="line" data-size="l" @click="closePopup()">{{ $t('COMMON.BUTTON.CAMEL.CANCEL')}}<!--취소--></button>
            </div>
            <div class="right-view">
                <button type="button" class="buttons"
                    data-type="key"
                    data-size="l"
                    @click="fnSaveRule"
                    :disabled="!isCopy && !isEdit && (invalidRuleTitle || invalidRuleCtgLabel)">
                        {{ $t('COMMON.BUTTON.CAMEL.OK')}}<!--확인-->
                </button>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'ManualRulePopup',
    props: {
        rule: Object,               // Popup 에서 control 될 Rule 정보
        categoryList: Array,        // 회사에 등록되어있는 Category Label 정보 리스트
        isEdit: Boolean,            // Edit 모드 활성화 플래그
        isCopy: Boolean,            // Copy 모드 활성화 플래그
        callLoading: Function,
        saveRule: Function,
        isFirstLoad: Boolean
    },
    data: function() {
        return {
            prodDynamicVal: ''                // Product 별 동적 필터 조건 값
            , prodDynamicInvalid: false         // Product 별 동적 필터 Validation check flag
            , cndDynamicInvalid: false         // Product 별 동적 필터 Validation check flag

            // 유효성 검사 값
            , invalidRuleTitle: true           // Rule Title 에 대한 invalid 구분
            , invalidRuleTitleMsg : ""          // Rule Title Invalid Message
            , invalidRuleDesc: false            // Rule Desc 에 대한 invalid 구분
            , invalidRuleCtgLabel: true        // Rule Category 에 대한 invalid 구분
            , invalidActionValue: false         // Action Value 에 대한 invalid 구분
            , invalidActionEmailUser: false     // Action Email 선택시 유저선택 에 대한 invalid 구분
            , svrtyOptions:[
                {key: '1', val: 'LABEL.SVRTY.1', dataIcon: 'low'},
                {key: '2', val: 'LABEL.SVRTY.2', dataIcon: 'medium'},
                {key: '3', val: 'LABEL.SVRTY.3', dataIcon: 'high'},
                {key: '4', val: 'LABEL.SVRTY.4', dataIcon: 'critical'}
            ]                               // 심각도 필터 옵션
        }
    },
    mounted: function() {
        this.initView();
        this.checkInputFields();
    },
    watch: {
        rule: function(){
            let self = this;
            _.find(this.rule.actnVal, function(o){
                o.actnId === self.constants.PARAM.SELECT.NULL ? o.actnId = self.constants.PARAM.SELECT.NONE: false
            });
        }
    },
    computed: {
        curLang() {
            return this.$i18n.locale;
        },
        getCtgFilterOptions: function() {
            let ctgFilter = []
            this.categoryList.forEach(function(r){
                ctgFilter.push({key:r.ctgId, val:r.ctgLabel})
            })
            return ctgFilter;
        },
    },
    methods: {
        checkInputFields() {
            if(!this.isFirstLoad) {
                // checkRuleName
                this.isInvalidRuleTitle();
                // checkCategory
                this.isInvalidRuleCategoryLabel();
            }
        },
        initView: function() {
            var self = this;
            // magnificPopup close Event override
            $.magnificPopup.instance.close = function () {
                // Popup invalid 초기화
                self.resetInvalid();
                // magnificPopup 의 proto close call
                $.magnificPopup.proto.close.call(this);
            };
        },
        fnSaveRule: function () {
            if (!this.isInvalidRuleTitle() && !this.isInvalidRuleCategoryLabel()) {
                this.callLoading(true);
                this.rule.autoExeYn = 'N';
                this.saveRule(this.rule);
                this.closePopup();
            }
        },
        // Rule Title 유효성 검사
        isInvalidRuleTitle() {
            if(this.Common.isEmptyText(this.rule.enRuleTitle) || this.Common.isEmptyText(this.rule.koRuleTitle)||this.Common.isEmptyText(this.rule.zhRuleTitle)){
                this.invalidRuleTitle = true;
                this.invalidRuleTitleMsg = this.$t('POLICY.RULE.INVALID.TITLE');

            }else{
                this.invalidRuleTitle = false;
            }
            return this.invalidRuleTitle;
        },
        // Rule Desc 유효성 검사
        isInvalidRuleDesc() {
            // this.Common.isEmptyText(this.rule.desc)
            this.invalidRuleDesc =
            ((this.rule.enRuleDesc && this.rule.enRuleDesc > 4000)&&
            (this.rule.koRuleDesc && this.rule.koRuleDesc > 4000)&&
            (this.rule.zhRuleDesc && this.rule.zhRuleDesc > 4000) )
            ? true : false;
            return this.invalidRuleDesc;
        },
        // Rule Category Label 선택 검사
        // 선택한 카테고리([]) 개수 검사해야함
        isInvalidRuleCategoryLabel() {
            this.invalidRuleCtgLabel = this.rule.ctgLabel.length < 1 ? true : false;

            this.invalidRuleCtgLabel ? $('.go-vendor.rule-select-ctg.ui.dropdown').attr("data-invalid", true) : $('.go-vendor.rule-select-ctg.ui.dropdown').removeAttr("data-invalid")

            return this.invalidRuleCtgLabel;
        },
        // Popup 의 invalid 초기화(false)
        resetInvalid() {
            this.invalidRuleTitle = false;
            this.invalidRuleDesc = false;
            this.invalidRuleCtgLabel = false;
            //$('.go-vendor.rule-select-ctg.ui.dropdown').removeAttr("data-invalid") // 나중에 멀티셀렉트 컴포넌트화 시켜서 다 옮겨버린다..
        },
        // close Popup
        closePopup() {
            $.magnificPopup.close();
            // EventBus.$emit('closeRulePopup')
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/bestpractice/systemManualRulePopup.vue